var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filter-column"},[_c('filter-age',{on:{"ageChange":function($event){return _vm.$emit('ageChange', _vm.data)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }